import { render } from "./tours-deals-com.vue?vue&type=template&id=30b9d258&scoped=true"
import script from "./tours-deals-com.vue?vue&type=script&lang=js"
export * from "./tours-deals-com.vue?vue&type=script&lang=js"

import "./tours-deals-com.vue?vue&type=style&index=0&id=30b9d258&scoped=true&lang=css"

import exportComponent from "/Users/achinthaprabasha/Desktop/work/yathra/yathra-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30b9d258"]])

export default __exports__